import * as React from 'react';
import {useState} from "react";
import { Cards } from './Card';
import { BlogCard } from './Newcard';
// import ItemCard from "./ItemCard";

import {useInventory} from "../../context/InventoryContext";
import useToggle from "../../shared/functions/useToggle";

import {Avatar, Stack, Typography, Chip} from "@mui/material";

import AntDataGrid from "../../shared/components/AntDataGrid";
// import AntDataGridDeux from "../../shared/components/AntDataGridDeux";
import InventoryDataGridToolbar from "./InventoryDataGridToolbar";
import InventoryOrdered from "./InventoryOrdered";
import InventoryForcasted from "./InventoryForcasted";
import InventoryDetails from "./InventoryDetails";
// import AddQuantity from '../orders/fragments/AddQuantity';
import NewQtyForMonth from './NewQtyForMonth';
import NewQtyToBuy from "../PurchaseCart/fragments/dataGrid/NewQtyToBuy";
// import ProductStatus from "./ProductStatus";
// import {Card, Col, Row} from "antd";
import {Card, Col, Row} from "antd";
import {makeStyles} from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";

import ItemsAutoComplete from "../_customs/ItemsAutoComplete";
import {getInventory, getItemInventory} from 'src/redux/slices/inventory/inventory.thunks'
import {useDispatch} from "react-redux";
import FilterListIcon from '@material-ui/icons/FilterList';
import ArtTrackTwoToneIcon from '@mui/icons-material/ArtTrackTwoTone';
import Icon, { AppstoreOutlined, MenuOutlined } from '@ant-design/icons';


import {Tooltip, Grid, Button,} from "@material-ui/core";
import FilterProductToPurchaseModal from './FilterProductToPurchaseModal';
import MoreVertIcon from '@mui/icons-material/MoreVert';
// import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import IconButton, { IconButtonProps } from '@mui/material/IconButton';
import { red } from '@mui/material/colors';
import FavoriteIcon from '@mui/icons-material/Favorite';
import ShareIcon from '@mui/icons-material/Share';
import TextField from '@mui/material/TextField';
import { auth } from 'src/config/firebaseConfig';


const useStyles = makeStyles((theme) => ({
    container: {
        width: 400,
        height: 400,
        margin: 10,
        cursor: "pointer",
        
    },
    avatar: {
        height: 400,
        width: 400
    },
    detailDiv: {
        marginLeft: 10
    },
    detailElement: {
        margin: 5,
        width: 200,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "clip",
    }
}))

const columns = [
    {
        title: 'Image', dataIndex: 'ImageUrl', key: 'ProductImageUrl',
        render: (image) => {
            return (
                <>
                    {
                        image
                            ? <Avatar alt={'...'} src={image}/>
                            : <Avatar>no</Avatar>
                    }
                </>
            )
        }
    },

    {
        title: 'Name', dataIndex: 'Name', key: 'Name',
        render: (val, {IsParent, HasChilds}) => {

            const ft = text => (text || '')?.trim()?.toLowerCase()

            const list = ['pack', ' pac ', ' pak ', ' pk '];

            let flag = ((IsParent || [])?.length > 0) || (HasChilds) || false

            list.forEach(label => {
                if (ft(val)?.includes(label))
                    flag = true
            })

            return (
                <Stack direction={'row'} spacing={1}>
                    <Typography>
                        {val}
                    </Typography>

                    {flag && (<Chip color={'success'} label={'Pk'}/>)}

                </Stack>
            )
        }
    },

    // {
    //     title: 'Seuil', dataIndex: 'Threshold', key: 'Threshold',
    //     render: (Threshold) => {
    //         return Threshold || 0
    //     }
    // }, <AddQuantity show={isCreateModalQuantityOpen}  itemData={selectedItem} onClose={handleCreateQuantityModalClosing}/>
  /*  {
        title: 'Qt. by month', dataIndex: '_', key: 'Stock',
        render: (_, record) => (
            <NewQtyForMonth {...record}/>
        )
    },*/

        {
            title: 'Month Qt.', dataIndex: '_', key: 'Stock',
            render: (_, {QuatityForMonth}) => QuatityForMonth ?? 0
        },

    {
        title: 'Qt. available', dataIndex: '_', key: 'Stock',

        render: (_, record) => (

            <InventoryForcasted {...record} />
        )
    },
    /*
        {
            title: 'Qt. forcasted', dataIndex: '_', key: 'Stock',
            render: (_, record) => (
                <InventoryOrdered {...record} />
            )
        },*/

    {
        title: 'Qt. to purchase', dataIndex: '_', key: 'Stock',
        render: (_, {QuantityToBuy}) => QuantityToBuy
    },

    {
        title: 'Qt. left to buy', dataIndex: '_', key: 'Stock',
        // render: (_, {RestQtyToBuy}) => RestQtyToBuy
        render: (_, RestQtyToBuy) => (
            <NewQtyToBuy {...RestQtyToBuy}             
            />
        )
    },

    // {
    //     title: 'Product Status', dataIndex: 'NotImportantToPurchase', key: 'Stock',
    //     render: (_, record) => (
    //         <ProductStatus {...record}  />
    //     )
    //     render: (NotImportantToPurchase, record) => (
    //         <span>
    //           {NotImportantToPurchase.map(NotImportantToPurchase => {
    //             let color = NotImportantToPurchase.length > 4 ? 'geekblue' : 'green';
    //             if (NotImportantToPurchase === 'false') {
    //               color = 'red';
    //             }
    //             return (
    //                 <ProductStatus {...record} />
    //             );
    //           })}
    //         </span>
    //       ),
    // },

];

const FILTER_INITIAL_STATE = {
    date: {start: null, end: null},
    delivery: {vendor: null}
};


function ItemCard(props){
    const classes = useStyles();
    const {data, loading, loadMore , aaa} = useInventory();
    const [open1, setOpen] = React.useState(false);
    const [open3, setOpen3] = React.useState(false);    
    
    
      const handleClose3 = () => {
        setOpen3(false);
      };
      const handleClose1 = () => {
        setOpen(false);
      };

    const dispatch = useDispatch();
    const [selected, setSelected] = useState(null)
    const [my_vendor_id, setMyVendorId] = useState("")
    const {open, handleClose, handleOpen} = useToggle()
    const {open: isCreateModalOpen, handleClose: handleOrderClose, handleOpen: handleOrderOpen} = useToggle()
    const {open: isCreateCartModalOpen, handleClose: handleCartClose, handleOpen: handleCartOpen} = useToggle()
    const {open: isCreateModalQuantityOpen, handleClose: handleQuantityClose, handleOpen: handleQuantityOpen} = useToggle()
    // const classes = useToolbarStyles();
    const {hide, filters, addToCartForFutureOder,addToValidationCartForFutureOder} = useInventory();
    const [selectedDate, handleDateChange] = useState(new Date());
    const [isFilterModalShown, setIsFilterModalShown] = useState(false); 

    const [qtyMonth, setQtyMonth] = useState(0)
    const [qtyCasa, setQtyCasa] = useState(0)
    const [qtyDekon, setQtyDekon] = useState(0)
    const [qtyInPo, setQtyInPo] = useState(0)
    const [qtyInShipping, setQtyInShipping] = useState(0)
    const [qtyToBuy, setQtyToBuy] = useState(0)
    const [VendorName, setVendorName] = useState(0)

    const handleDate2Change = (value) => {
        handleDateChange(value) 
        var month = value.getMonth()+1
        var filterbyData = value.getDate()+"-"+month+"-"+value.getFullYear()

        var date = new Date(filterbyData)

        var goodDAte = month +"-"+value.getDate()+"-"+value.getFullYear() 

        dispatch(getInventory(null, false, 100, null, new Date(goodDAte)))
    }


    const handleSelection = selected => {

        if (selected) {
            dispatch(getItemInventory(filters, selected?.id))
            // console.log(selectedItem?.hasToBuy)
        } else {
            dispatch(getInventory(filters))
            // console.log(selectedItem?.hasToBuy)
        }

        setSelected(selected)
        // console.log(selectedItem?.hasToBuy)
    }

    
    const handleFilterModalClosing = () => {
        setIsFilterModalShown(false)
    };

    const handleFilterChange = (filter) => {
        dispatch(getInventory(filters, false, 100, null,  ""))
    }
    const handleFilterModalShowing = () => {
        setIsFilterModalShown(true)
    }

    const handleClickOpen = (qtyMonth,qtyCasa,qtyDekon,qtyInPo,qtyInShipping) => {
        setQtyMonth(qtyMonth);
        setQtyCasa(qtyCasa);
        setQtyDekon(qtyDekon);
        setQtyInPo(qtyInPo);
        setQtyInShipping(qtyInShipping);
        setOpen(true);
      };

      const handleClickOpen3 = (qtyMonth,qtyToBuy,VendorName) => {
        setQtyMonth(qtyMonth);
        setQtyToBuy(qtyToBuy);
        setVendorName(VendorName)
        setOpen3(true);
      };

      const addtocart = ()=>{

      }
      const removefromcart = ()=>{
        
      }

    // const handleDisable = () => hide(selectedItem?.map(one => one?.id)) 

    // const handleAddToCart = () => addToCartForFutureOder(selectedItem) 
    
    const handleCreateOrderModalClosing = () => {
        handleOrderClose()
    }
    const handleCreateCartModalClosing = () => {
        handleCartClose()
    }
    const handleCreateQuantityModalClosing = () => {
            handleQuantityClose()
    }
    

    
    return (
        <>
    <section style={{marginTop: 20}}>
        <ItemsAutoComplete value={selected} onChange={handleSelection} minWidth={700}/>
        
    <Row>
        {
            data.map(item => (
                <>
                <Col alignItems="center"
  justify="center" >
                    <Box className={classes.container} boxShadow={2} style={{height:'550px'}}>

                <Card sx={{ maxWidth: 345 }} style={{height:'100%',margin:'25px',padding:'25px'}}>
      <CardHeader
        action={
          <IconButton aria-label="settings">
            <MoreVertIcon onClick={()=>handleClickOpen3(item.QuatityForMonth,item.QuantityToBuy,item?.Vendors?.Id?.Name)}/>
          </IconButton>
        }
        title=""
        subheader=""
      />
      <img
        src={item.ImageUrl}
        alt="Paella dish"
        style={{width:'100%',height: '200px',margin: '0 auto'}}
      />
      <CardContent>
        <p style={{fontSize:'12px',fontWeight:'bold'}}>
        {item.Name}
        </p>
        <h3 style={{fontSize:'12px',fontWeight:'bold'}}>
        {item.UPC}
        </h3>
      </CardContent>
      <CardActions disableSpacing>
        <IconButton aria-label="add to favorites">
            <Chip label={((item?.Stores?.Cassablanca?.Quantity)+(item?.Stores?.Dekon?.Quantity)+(item.QuantityInPO)+(item.QuantityInShpping)) || 0} color={'success'} style={{marginRight:15}} 
                    onClick={()=>handleClickOpen(item.QuatityForMonth,item?.Stores?.Cassablanca?.Quantity,item?.Stores?.Dekon?.Quantity,item.QuantityInPO,item.QuantityInShpping)} />
          {/* <FavoriteIcon /> */}
        </IconButton>
        <IconButton aria-label="share">
           <Chip label={(item.QuatityForMonth) || 0} color={'secondary'} style={{marginRight:15}}/>
        </IconButton>
        <IconButton aria-label="share">
            <Chip label={(item.QuatityToBuy) || 0} style={{marginRight:15}}/>
        </IconButton>
      </CardActions>
      
    
    </Card>
                     </Box>
                </Col>
             
              </>
            ))
        }
        </Row>
        {/* Modal d'affichage des details d'un produit */}
             <Dialog
                open={open1}
                onClose={handleClose1}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <DialogTitle id="alert-dialog-title">
                  {"Inventory Details"}
                </DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description" style={{width:350,fontWeight:'bold'}}>
               <Chip label={"For Month:"} style={{width:100,textAlign:'left'}}/> {qtyMonth} <br/><br/>
               <Chip label={"Casa:"} style={{width:100,textAlign:'left'}}/> {qtyCasa} <br/><br/>
               <Chip label={"Dekon:"} style={{width:100,textAlign:'left'}}/>  {qtyDekon} <br/><br/>
               <Chip label={"Po:"} style={{width:100,textAlign:'left'}}/>  {qtyInPo} <br/><br/>
               <Chip label={"Ship:"} style={{width:100,textAlign:'left'}}/>{qtyInShipping}
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  {/* <Button onClick={handleClose1}>X</Button> */}
                  <Button onClick={handleClose1} autoFocus>
                  
                    Close
                  </Button>
                </DialogActions>
              </Dialog>
               {/*Fin Modal d'affichage des details d'un produit */}
                {/* Modal d'action https://mui.com/joy-ui/react-modal/ */}
                <Dialog open={open3} onClose={handleClose3}>
                      <DialogTitle>for month: {qtyMonth} | Prévu: {qtyMonth*3} | {VendorName}</DialogTitle>
                    <DialogContent>
                      <DialogContentText>
                        
                      </DialogContentText>
                        <TextField
                            autoFocus
                            margin="dense"
                            id="name"
                            label="Quantity To Buy"
                            type="number"
                            fullWidth
                            variant="standard"
                            
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose3}>Cancel</Button>
                        <Button onClick={addtocart} variant="contained" color='primary' style={{width:'auto'}}>Add To Cart - VendorName</Button>
                        <Button onClick={removefromcart} variant="contained" style={{width:'auto',backgroundColor:'#dc3545'}}>Remove From Cart</Button>
                    </DialogActions>
      </Dialog>
                {/* Fin Modal d'action */}
    </section>
    
  </>
    )
}

function DisplayCard(props){
    const {data, loading, loadMore} = useInventory();
    const dispatch = useDispatch();
    const [selected, setSelected] = useState(null)
    const handleSelection = selected => {

        if (selected) {
            dispatch(getItemInventory(filters, selected?.id))
            // console.log(selectedItem?.hasToBuy)
        } else {
            dispatch(getInventory(filters))
            // console.log(selectedItem?.hasToBuy)
        }

        setSelected(selected)
        // console.log(selectedItem?.hasToBuy)
    }
    const handleFilterModalClosing = () => {
        setIsFilterModalShown(false)
    };

    const handleFilterChange = (filter) => {
        dispatch(getInventory(filters, false, 100, null,  ""))
    }
    const handleFilterModalShowing = () => {
        setIsFilterModalShown(true)
    }

    const {hide, filters, addToCartForFutureOder,addToValidationCartForFutureOder} = useInventory();
    const [selectedDate, handleDateChange] = useState(new Date());
    const [isFilterModalShown, setIsFilterModalShown] = useState(false);
    
    const handleActionClick = () => {
        alert('Action button clicked!');
        // Add your custom action logic here
      };
      const handleEllipsisClick = () => {
        alert('Ellipsis button clicked!');
        // Add your custom ellipsis action logic here
      };
    return(
        <>
        {/* <section style={{marginTop: 20}}> */}
            <ItemsAutoComplete value={selected} onChange={handleSelection} minWidth={700} style={{color: "red"}}/>
<div className="row">
      {data?.map((title) => {
        return (
            // <BlogCard />
          <Cards
            lb={title.Badge}
            id={title.id}
            lastprice={title.LastBuyPrice}
            formouth={title.QuatityForMonth}
            title={title.Name}
            imageurl={title.ImageUrl}
            body={title.UPC}
            QuantityInPO={title.QuantityInPO}
            QuantityInShpping={title.QuantityInShpping}
            QuantityCasa={title.Stores.Cassablanca.Quantity}
            QuantityDekon={title.Stores.Dekon.Quantity}
            QuantityToBuy={title.QuantityToBuy}
            RestQtyToBuy={title.RestQtyToBuy}
            OrderInfos={title.OrderInfo? title.OrderInfo : null}
            onActionClick={handleActionClick}
            onEllipsisClick={handleEllipsisClick}

          />
        );
      })}
    </div>
       {/* </section> */}
       </>
    )
}


export default function InventoryDataGrid() {
    const {data, loading, loadMore ,aaa} = useInventory();
    const [listcard,setListCard]= useState('card');

    
    // console.log(data[0])
    const classes = useStyles();

    //localStorage.setItem('ComposeFilter', JSON.stringify(FILTER_INITIAL_STATE));

    const handleSelection = record => {
        //console.log("kkKK"+JSON.stringify(record))
        setSelected(record)
        handleOpen();
    }
    const handleOneSelection = record => {
        //console.log("kkKK"+JSON.stringify(record))
        setSelected(record)
        handleOpen();
    }

    const handleDetailModalClosing = () => {
        setSelected(null)
        handleClose()
    }

    const handlePageChange = (current, total) => (current === (total - 1) || current === total) && loadMore()
    const handleFilterModalShowing = () => {
        setIsFilterModalShown(true)
    }
    const handleTableShowing = (etat) =>{
        if(etat=='card'){
            setListCard('card');
        }
        else{
            setListCard('list');
        }
    }

    
 
    const dispatch = useDispatch();
    const [selected, setSelected] = useState(null)
    const [my_vendor_id, setMyVendorId] = useState("")
    const {open, handleClose, handleOpen} = useToggle()
    const {open: isCreateModalOpen, handleClose: handleOrderClose, handleOpen: handleOrderOpen} = useToggle()
    const {open: isCreateCartModalOpen, handleClose: handleCartClose, handleOpen: handleCartOpen} = useToggle()
    const {open: isCreateModalQuantityOpen, handleClose: handleQuantityClose, handleOpen: handleQuantityOpen} = useToggle()
    const {hide, filters, addToCartForFutureOder,addToValidationCartForFutureOder} = useInventory();
    const [selectedDate, handleDateChange] = useState(new Date());
    const [isFilterModalShown, setIsFilterModalShown] = useState(false); 

    const handleDate2Change = (value) => {
        handleDateChange(value) 
        var month = value.getMonth()+1
        var filterbyData = value.getDate()+"-"+month+"-"+value.getFullYear()

        var date = new Date(filterbyData)

        var goodDAte = month +"-"+value.getDate()+"-"+value.getFullYear() 

        dispatch(getInventory(null, false, 100, null, new Date(goodDAte)))
    }
    const handleFilterModalClosing = () => {
        setIsFilterModalShown(false)
    };

    const handleFilterChange = (filter) => {
        dispatch(getInventory(filters, false, 100, null,  ""))
    }
    
    return (
        <>
        <FilterProductToPurchaseModal 
                show={isFilterModalShown}
                onSet={handleFilterChange}
                onClose={handleFilterModalClosing}
            />
            
        <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <Col>
                                <Button onClick={handleFilterModalShowing}>
                                    <FilterListIcon/>
                                    {' Filter'}
                                </Button>
                                
                                    {listcard=='card'?
                                    <Button onClick={()=>handleTableShowing('list')}>
                                    <MenuOutlined />
                                     SHOW LIST | TOTAL D'ITEMS: {data.length}
                                    </Button>:
                                     <Button onClick={()=>handleTableShowing('card')}>
                                     <AppstoreOutlined />
                                     SHOW CARD | TOTAL D'ITEMS: {data.length}
                                     </Button>}    
                            </Col>
                         </Grid>
                     </Grid>
        {
                listcard =='card'?<DisplayCard />:
                <AntDataGrid
                data={data}
                columns={columns}
                isLoading={loading}
                ToolBar={InventoryDataGridToolbar}
                onPageChange={handlePageChange}
                doubleClickAction={handleSelection}
                shadows
            />
            }

            
           {
                selected && (
                    <InventoryDetails
                        open={open}
                        item={selected}
                        onClose={handleDetailModalClosing}
                    />
                )
            }
            
        </>
    )

}